import * as React from 'react';
import * as UI from 'core/ui';
import * as Images from 'pos/Images';

import { Command } from 'pos/common';
import { ActionButtonDefinition, DialogIcon, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import { Permission, Res } from 'core/api';
import { RestaurantFacade } from 'pos/facades';
import { Preconditions } from 'core/infrastructure-next';
import { Cols, Col } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type Props = {
	lastPreparationNumber: number;
} & Modal.Actions<number>;

type State = {
	value: Nullable<number>;
};

class GetResetPreparationCounter extends PosScreenClassComponent<Props, State> {

	private form = React.createRef<UI.Form<State>>();

	protected getScreenId(): string {
		return 'RESET_PREPARATION_COUNTER';
	}

	protected getTitle(): string {
		return Res.Web.RESET_PREPARATION_COUNTER();
	}

	protected getImage(): string | SvgIcon {
		return Images.PreparationCounter;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return this.okCancelButtons({ onOK: this.onOk });
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	private onOk = async () => {
		const valid = await this.form.current!.updateModel();
		if (valid && this.state.value)
			this.close(this.state.value);
	};

	protected getContent(): React.ReactNode {
		const { Form, IntBox } = UI.controlsFor<State>();

		return <Form small ref={this.form} model={this.state}>
			<DialogIcon src={Images.PreparationCounter} />
			<Cols>
				<Col width='*' className='text-center m-t-sm text-18'>
					{Res.Web.RESET_PREPARATION_COUNTER_LAST_NUMBER_LBL()} {this.props.lastPreparationNumber}
				</Col>
			</Cols>
			<Cols>
				<Col width='*' className='m-t-sm'>
					<IntBox className='text-center' placeholder={Res.Web.RESET_PREPARATION_COUNTER_NUMBER_LBL()} linkTo={x => x.value} allowNegative={false} onKeyDown={UI.whenEnterKey(this.onOk)} rules={[UI.Constraints.greaterThanZero, UI.Constraints.maxLength(3)]} maxLength={3} />
				</Col>
			</Cols>
		</Form>;
	}

	createInitialState(_props: Props): Nullable<State> {
		return { value: null };
	}

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}
}

declare global {
	interface CommandType {
		resetPreparationCounter: () => Promise<Result>
	}
}

Command.register('resetPreparationCounter', Preconditions.ensure(Permission.PreparationCounter_Reset), async (): Promise<Result> => {
	const lastPreparationNumber = await RestaurantFacade.getPreparationCounterLastNumber();

	const result = await Modal.show(GetResetPreparationCounter, { lastPreparationNumber: lastPreparationNumber });

	if (result.ok)
		await RestaurantFacade.setPreparationCounterLastNumber(result.value - 1);

	return result;
});